import { Banner } from "baseui/banner"
import { FormattedMessage, useIntl } from "react-intl"
import { useSetObjectValue } from "../../../hooks/useSetObjectValue";
import { ValueDisplayWithLabel } from "../../components/ValueDisplay";
import { ICounter } from "./types"

export function CounterDisabledInfo(props: ICounter) {
    const intl = useIntl();
    const [enableCounter, setEnableCounter] = useSetObjectValue(props.id, props.resourceGroupId, "enableCounter", props.enableCounter);

    if (enableCounter)
        return (<></>)

    return (
        <>
            { props.value > 0 &&
                <Banner title={<FormattedMessage id="Counter.DisabledTitle" defaultMessage={"Counter is disabled"}></FormattedMessage>} kind='info' action={{
                    label: intl.formatMessage({ id: "Counter.Enable", defaultMessage: "enable" }),
                    onClick: () => { setEnableCounter(true) },
                }}>
                    <FormattedMessage id="Counter.TextDisabled" defaultMessage="The Counter is disabled. You Can enable the counter in the konfiguration tab."></FormattedMessage>
                    <ValueDisplayWithLabel small value={props.value} dimension={props.dimension} label="Total"></ValueDisplayWithLabel>
                </Banner>
            }
            { props.value <= 0 &&
                <Banner title={<FormattedMessage id="Counter.DisabledTitle" defaultMessage={"Counter is disabled"}></FormattedMessage>} kind='warning'>
                    <FormattedMessage id="Counter.TextDisabledAndNotValid" defaultMessage="The Counter is disabled and the value is not Valid. As soon as the value is valid you can activate the counter."></FormattedMessage>
                </Banner>
            }
        </>
    )
}

